import { Script, platform } from 'playcanvas';
import Taps from '../libs/mr-tap.js';


class Input extends Script {
    initialize() {
        this.xScale = platform.mobile ? 3 : 1;
        this.yScale = 1.4;

        this.taps = new Taps();

        this.activeTaps = new Set();

        window.addEventListener('wheel', (event) => {
            if (event.target !== this.app.graphicsDevice.canvas) return;

            this.app.fire('input:zoom', event.deltaY);
        });
    }

    update() {
        this.taps.update();

        for (const tap of this.taps.start) {
            this.activeTaps.add(tap);
        }

        for (const tap of this.taps.up) {
            this.activeTaps.delete(tap);
            this.lastDistance = null;
        }

        if (this.activeTaps.size === 1) {
            for (const tap of this.taps.drag) {
                this.app.fire('input:drag', tap.dx * this.xScale, tap.dy * this.yScale);
            }

            return;
        }

        const taps = Array.from(this.taps);
        if (taps.length !== 2) return;

        const distance = Math.hypot(
            taps[0].x - taps[1].x,
            taps[0].y - taps[1].y
        );

        if (this.lastDistance) {
            const delta = this.lastDistance - distance;

            if (Math.abs(delta) > 1) {
                this.app.fire('input:zoom', delta * 3.5);
            }
        }

        this.lastDistance = distance;
    }
}

const script = {
    class: Input,
    name: 'input'
};

export default script;